const extractRootPath = pathname => {
  if (!pathname) return false;
  const pathSegments = pathname.split('/');
  if (!pathSegments) {
    return false;
  }
  return pathSegments && pathSegments.length >= 1 && pathSegments[1];
};

module.exports = {
  extractRootPath
};
